// src/hooks/useClientId.js
import { Buffer } from 'buffer';
import { useSelector } from "react-redux";
import { onGetDealsPostLogin } from '../Store/Slices/dealsDataSlice';

const ClientId = () => {
  return useSelector(
    (state) =>
      state.clientMasterReducer?.clientMasterData?.[0]?.clientId || null
  );
};

const ClientPlatformCode = () => {
  return useSelector((state) => {
    const clientCode = state.clientMasterReducer?.clientMasterData?.[0]?.name || "";
    const platformCode = "MyStacc";
    return {
      clientCode, platformCode
    };
  });
};
const UserIdAndStatusData = () => {
  return useSelector((state) => {
    const userId = state.validateLoginTokenSliceReducer?.data?.id || undefined;
    const userStatus = state.validateLoginTokenSliceReducer?.data?.id ? "logged_in" : "guest";
    const customerIdentifier = state.validateLoginTokenSliceReducer?.data?.memberIdentifier || undefined;
    return {
      userId, userStatus, customerIdentifier
    };
  });
};

const ModalOrSso = () => {
  return useSelector(
    (state) => state.clientMasterReducer?.clientMasterData?.[0]?.isModal
  );
};

const UserId = () => {
  return useSelector((state) => state.loginReducer?.data?.[0]?.userId || null);
};

const SectionMasterData = (login) => {
  return useSelector((state) => {
    const data = state?.homePageSliceReducer?.homePageData?.sectionMasters || [];
    const isSectionLoading = login ? state?.homePageSliceReducer?.isPostLoginLoading : state?.homePageSliceReducer?.isgetLoading;
    return {
      sectionMasterData: data?.filter((filterData) => filterData?.enabled)
        .sort((a, b) =>
          !login
            ? a.nonLoginDisplayOrder - b.nonLoginDisplayOrder
            : a.displayOrder - b.displayOrder
        ),
      isSectionLoading,
    };
  });
};

const SectionContentMasterData = () => {
  return useSelector((state) => {
    const data =
      state?.homePageSliceReducer?.homePageData?.sectionContentMasters || [];
    const isLoading = state?.homePageSliceReducer?.isPostLoginLoading ? state?.homePageSliceReducer?.isPostLoginLoading : state?.homePageSliceReducer?.isgetLoading;
    return {
      sctionContentdata: data?.filter((filterData) => filterData?.enabled)
        .sort((a, b) => a.displayOrder - b.displayOrder),
      isLoading,
    };
  });
};

const MyAccountSectionMasterData = (login) => {
  return useSelector((state) => {
    const data = state?.myAccountPageReducer?.getData?.sectionMasters || [];
    const isMyAccountSectionLoading = state?.myAccountPageReducer?.isgetLoading;
    return {
      myAccountsectionMasterData: data?.filter((filterData) => filterData?.enabled)
        .sort((a, b) =>
          !login
            ? a.nonLoginDisplayOrder - b.nonLoginDisplayOrder
            : a.displayOrder - b.displayOrder
        ),
      isMyAccountSectionLoading,
    };
  });
};

const MyAccountSectionContentMasterData = () => {
  return useSelector((state) => {
    const data =
      state?.myAccountPageReducer?.getData?.sectionContentMasters || [];
    const isLoading = state?.myAccountPageReducer?.isgetLoading;
    return {
      myAccountSctionContentdata: data?.filter((filterData) => filterData?.enabled)
        .sort((a, b) => a.displayOrder - b.displayOrder),
      isLoading,
    };
  });
};

const ProductContentData = () => {
  return useSelector((state) => {
    const data = state?.homePageSliceReducer.homePageData.productContents?.filter(
      (data) => data?.enabled
    ) || [];
    const isProductLoading = state?.productContentReducer?.isLoading;
    return {
      productContentData: data,
      isProductLoading,
    };
  });
};

const DealCategoryData = () => {
  return useSelector((state) => {
    const data = state?.homePageSliceReducer?.homePageData?.dealCategories || [];
    const isDealCategoryLoading = state?.homePageSliceReducer?.homePageData?.isLoading;
    return {
      dealCategoryData: data
        ?.filter((filterData) => filterData?.enabled)
        .sort((a, b) => a.displayOrder - b.displayOrder),
      isDealCategoryLoading,
    };
  });
};

const DealData = () => {
  return useSelector((state) => {
    const data = state?.homePageSliceReducer?.homePageData?.deals || [];
    const isDealLoading = state?.homePageSliceReducer?.homePageData?.isLoading;
    return {
      dealData: data
        ?.filter((filterData) => filterData?.enabled)
        .sort((a, b) => a.displayOrder - b.displayOrder),
      isDealLoading,
    };
  });
};

const DealCouponData = () => {
  return useSelector((state) => {
    const data = state?.homePageSliceReducer?.homePageData?.dealCoupouns || [];
    const isDealCouponLoading = state?.homePageSliceReducer?.homePageData?.isLoading;
    return {
      dealCouponData: data?.filter((filterData) => filterData?.enabled),
      isDealCouponLoading,
    };
  });
};

const DealCouponFreqData = () => {
  return useSelector((state) => {
    const data = state?.homePageSliceReducer?.homePageData?.dealCoupounFrequencies || [];
    const isDealFreqLoading = state?.homePageSliceReducer?.homePageData?.isLoading;
    return {
      dealCouponFreqData: data?.filter(
        (filterData) => filterData?.enabled
      ),
      isDealFreqLoading,
    };
  });
};

const DealCouponCodeData = () => {
  return useSelector((state) => {
    const data = state?.homePageSliceReducer?.homePageData?.dealCoupounCodes || [];
    const isDealCouponCodeLoading = state?.homePageSliceReducer?.homePageData?.isLoading;
    const isDealCouponCodePostLoading =
      state?.dealCouponCodeReducer?.isPostLoading;

    return {
      dealCouponCodeData: data?.filter((filterData) => filterData?.enabled),
      isDealCouponCodeLoading,
      isDealCouponCodePostLoading,
    };
  });
};

const UnlocksectionactivityData = () => {
  return useSelector((state) => {
    const data = state?.homePageSliceReducer?.homePageData?.unlockSectionActivities || [];
    const isUnlockDataLoading = state?.homePageSliceReducer?.homePageData?.isLoading;
    return {
      unlockData: data?.filter((filterData) => filterData?.enabled),
      isUnlockDataLoading,
      get_status_code: state?.homePageSliceReducer?.homePageData?.get_status_code,
    };
  })
}

const GetMemberData = () => {
  return useSelector((state) => state.validateLoginTokenSliceReducer?.data);
};
const GetSegment = () => {
  return useSelector((state) => state.SegmentSliceReducer);
};
const GetSwitchAccount = () => {
  return useSelector((state) => state.switchAccountSliceReducer);
};
const PointPerPrice = () => {
  return useSelector(
    (state) => state.clientMasterReducer?.clientMasterData?.[0]?.pointPerRs
  );
};
const AppTitle = () => {
  return useSelector(
    (state) => state.clientMasterReducer?.clientMasterData?.[0]
  );
};
const AppLogo = () => {
  return useSelector(
    (state) => state.clientMasterReducer?.clientMasterData?.[0]?.logoUrl
  );
};
const NavConfigureData = () => {
  return useSelector((state) => {
    const data = state?.homePageSliceReducer?.homePageData?.navConfigures || [];
    const isNavConfigureLoading = state?.homePageSliceReducer?.homePageData?.isLoading;
    return {
      navConfigureData: data
        ?.filter((filterData) => filterData?.enabled)
        .sort((a, b) => a.displayOrder - b.displayOrder),
      isNavConfigureLoading,
    };
  });
};
const ApiConfigData = () => {
  return useSelector((state) => state?.apiConfigReducer?.getApiConfigData);
};
const ApiConfigDataLoading = () => {
  return useSelector((state) => state?.apiConfigReducer?.isgetLoading);
};
const ThemeData = () => {
  return useSelector(
    (state) => state?.themeMasterReducer?.getThemeMasterData?.[0]
  );
};
const ThemeDataLoading = () => {
  return useSelector((state) => state?.themeMasterReducer?.isgetLoading);
};
const ValidateLoginToken = () => {
  return useSelector((state) => state?.validateLoginTokenSliceReducer?.data);
};
const UtilityReducer = () => {
  return useSelector((state) => state?.utilityReducer);
};
const UserCardBase = () => {
  return useSelector((state) => state?.userCardBaseReducer);
};
const handleRedirectWithLoading = (
  setIsLoading,
  url,
  login,
  setShowModal,
  isModal,
  navigate,
  loginUrl,
) => {
  if (!login === true && isModal) {
    setShowModal(true);
    navigate && navigate("/");
  } else if (!login === true && isModal !== true) {
    setIsLoading(true);
    window.open(loginUrl, "_self");
    setTimeout(() => setIsLoading(false), 10000);
  } else {
    setIsLoading(true);
    window.open(url, "_self");
    setTimeout(() => setIsLoading(false), 10000);
  }
};
const FormatDate = (date) => {
  if (!date) return null;
  const d = new Date(date);

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const day = d.getDate().toString().padStart(2, "0");
  const month = months[d.getMonth()];
  const year = d.getFullYear();

  return `${day} ${month} ${year}`;
};
const VoucherHistoryReducer = () => {
  return useSelector((state) => state?.voucherHistoryReducer);
};
const CustomFormatNumber = (input) => {

  let str = typeof input === "string" ? input : input?.toString();
  if (str?.length <= 3) return str;

  let result = [str?.slice(-3)];
  let remaining = str?.slice(0, -3);

  while (remaining?.length) {
    result?.push(remaining?.slice(-2));
    remaining = remaining?.slice(0, -2);
  }

  return result?.reverse().join(",");

};
const FetchDealData = (dispatch, segments, login, loginAuthData, pageNo, pageSize) => {
  let customerSegmentId = "";
  if (segments?.length === 1) {
    customerSegmentId = segments[0]?.segmentId;
  } else if (segments?.length > 1) {
    customerSegmentId = segments.map((element) => element?.segmentId).join(",");
  }
  if (customerSegmentId) {
    dispatch(onGetDealsPostLogin({}));
  } else {
  }
};
const isValidColor = (color) => {
  const s = new Option().style;
  s.color = color;
  return s.color !== "";
};
const ApplyThemeStyles = (themeData) => {
  const setStyle = (variable, color, fallback) => {
    document.documentElement.style.setProperty(
      variable,
      isValidColor(color) ? color : fallback
    );
  };

  setStyle("--bs-white-2", themeData?.commonhgElementSurfaceColor, "#FCF1F2");
  setStyle("--bs-light-1-black", themeData?.headerTextColor, "#222222");
  setStyle("--bs-white", themeData?.headerBackgroundColor, "#fff");
  setStyle("--bs-black-3", themeData?.headerBorderColor, "#ffffff");
  setStyle("--bs-white-7", themeData?.primaryBgColor, "#fff");
  setStyle("--bs-light-2-black", themeData?.primaryText, "#222222");
  setStyle("--bs-light-4-black", themeData?.secondaryText, "#222222");
  setStyle("--primary-green", themeData?.earnElementColor, "#00AE4E");
  setStyle("--earn-bg", themeData?.earnSurfaceColor, "#E5F7ED");
  setStyle("--bs-card-name", themeData?.cardNameTextColor, "#222222");
  setStyle("--bs-white-7", themeData?.commonElementBackgroundColor, "#fff");
  setStyle("--bs-red-2", themeData?.commonElementBorderColor, "#9a1b24");
  setStyle("--bs-red-2", themeData?.commonElementTextColor, "#9a1b24");
};
const TruncateName = (name = "", maxLength = 20) => {
  if (!name || name.length <= maxLength) return name;

  const words = name.split(/[\s-]/);
  let result = "";

  for (let word of words) {
    if ((result + word).length <= maxLength) {
      result += (result ? " " : "") + word;
    } else {
      break;
    }
  }

  return result + "...";
};
const clientType = process.env.REACT_APP_CLIENT_TYPE;
const Login = sessionStorage.getItem("login");
const GetImageUrl = (imagePath) => {
  return `${process.env.REACT_APP_CLIENT_IMAGE_URL}${imagePath}`;
};
const ShouldShowSection = (sectionData, login, isMobileView) => {
  const isJourneyTypeValid =
    (sectionData?.journeyType === true && login) ||
    (sectionData?.journeyType === false && !login) ||
    sectionData?.journeyType === null;

  const isScreenTypeValid =
    (sectionData?.deviceType === true && isMobileView) ||
    (sectionData?.deviceType === false && !isMobileView) ||
    sectionData?.deviceType === null;
  return isJourneyTypeValid && isScreenTypeValid;
};
const GetMobWebCta = (compoData, isMobileView) => {
  if (!compoData) return null;

  if (Array.isArray(compoData)) {
    return isMobileView ? compoData?.[0]?.mobCta : compoData?.[0]?.cta;
  }
  return isMobileView ? compoData?.mobCta : compoData?.cta;
};


// Old Functions for Deal Data Fetching

const SectionMasterData_2 = (login) => {
  return useSelector((state) => {
    const data = state?.sectionMasterReducer?.getsectionMasterData || [];
    const sectionLoading = state?.sectionMasterReducer?.isgetLoading;
    return {
      sectionMasterData: data?.items?.filter((filterData) => filterData?.enabled)
        .sort((a, b) =>
          !login
            ? a.nonLoginDisplayOrder - b.nonLoginDisplayOrder
            : a.displayOrder - b.displayOrder
        ),
      sectionLoading,
    };
  });
};

const SectionContentMasterData_2 = () => {
  return useSelector((state) => {
    const data =
      state?.sectionContentMasterReducer?.getSectionContentMasterData || [];
    const isLoading = state?.sectionContentMasterReducer?.isgetLoading;
    return {
      sctionContentdata: data?.items?.filter((filterData) => filterData?.enabled)
        .sort((a, b) => a.displayOrder - b.displayOrder),
      isLoading,
    };
  });
};
const ProductContentData_2 = () => {
  return useSelector((state) => {
    const data =
      state?.productContentReducer?.data?.items?.filter((data) => data?.enabled) || [];
    const isProductLoading = state?.productContentReducer?.isLoading;
    return {
      productContentData: data,
      isProductLoading,
    };
  });
};

const DealCategoryData_2 = () => {
  return useSelector((state) => {
    const data = state?.dealCategoryReducer?.getDealCategoryData || [];
    const isDealCategoryLoading = state?.dealCategoryReducer?.isgetLoading;
    return {
      dealCategoryData: data?.items?.filter((filterData) => filterData?.enabled)
        .sort((a, b) => a.displayOrder - b.displayOrder),
      isDealCategoryLoading,
    };
  });
};

const DealData_2 = () => {
  return useSelector((state) => {
    const data = state?.dealReducer?.getDealData || [];
    const isDealLoading = state?.dealReducer?.isgetLoading;
    return {
      dealData: data?.items?.filter((filterData) => filterData?.enabled)
        .sort((a, b) => a.displayOrder - b.displayOrder),
      isDealLoading,
    };
  });
};

const DealCouponData_2 = () => {
  return useSelector((state) => {
    const data = state?.dealCouponReducer?.getDealCouponData?.items;
    const isDealCouponLoading = state?.dealCouponReducer?.isgetLoading;
    return {
      dealCouponData: data?.filter((filterData) => filterData?.enabled),
      isDealCouponLoading,
    };
  });
};

const DealCouponFreqData_2 = () => {
  return useSelector((state) => {
    const data = state?.dealCouponFreqReducer?.getDealCouponFreqData || state?.homePageSliceReducer?.homePageData?.dealCoupounFrequencies;
    const isDealFreqLoading = state?.dealCouponFreqReducer?.isgetLoading;
    return {
      dealCouponFreqData: state?.dealCouponFreqReducer?.getDealCouponFreqData ? data?.items?.filter((filterData) => filterData?.enabled) : data?.filter((filterData) => filterData?.enabled),
      isDealFreqLoading,
    };
  });
};

const DealCouponCodeData_2 = () => {
  return useSelector((state) => {
    const data = state?.dealCouponCodeReducer?.getDealCouponCodeData || [];
    const isDealCouponCodeLoading = state?.dealCouponCodeReducer?.isgetLoading;
    const isDealCouponCodePostLoading =
      state?.dealCouponCodeReducer?.isPostLoading;

    return {
      dealCouponCodeData: data?.filter((filterData) => filterData?.enabled),
      isDealCouponCodeLoading,
      isDealCouponCodePostLoading,
    };
  });
};



// Offer List Data Fetching Function

const OfferSectionMasterData = (login) => {
  return useSelector((state) => {
    const data = state?.dealsDataSlice?.allofferData?.sectionMasters || [];
    const offerSectionLoading = state?.allofferData?.isLoading;
    return {
      sectionMasterData: data?.filter((filterData) => filterData?.enabled)
        .sort((a, b) =>
          !login
            ? a.nonLoginDisplayOrder - b.nonLoginDisplayOrder
            : a.displayOrder - b.displayOrder
        ),
      offerSectionLoading,
    };
  });
};

const OfferSectionContentMasterData = () => {
  return useSelector((state) => {
    const data = state?.dealsDataSlice?.allofferData?.sectionContentMasters || [];
    const isLoading = state?.dealsDataSlice?.allofferData?.isLoading;
    return {
      sctionContentdata: data?.filter((filterData) => filterData?.enabled)
        .sort((a, b) => a.displayOrder - b.displayOrder),
      isLoading,
    };
  });
};

const OfferDealCategoryData = () => {
  return useSelector((state) => {
    const data = state?.dealsDataSlice?.allofferData?.filteredDealCategories || [];
    const isDealCategoryLoading = state?.dealsDataSlice?.allofferData?.isLoading;
    return {
      dealCategoryData: data,
      isDealCategoryLoading,
    };
  });
};

const OfferDealData = () => {
  return useSelector((state) => {
    const data = state?.dealsDataSlice?.allofferData?.deals || [];
    const isDealLoading = state?.dealsDataSlice?.allofferData?.isLoading;
    return {
      dealData: data?.filter((filterData) => filterData?.enabled)
        .sort((a, b) => a.displayOrder - b.displayOrder),
      isDealLoading,
    };
  });
};

const OfferDealCouponData = () => {
  return useSelector((state) => {
    const data = state?.dealsDataSlice?.allofferData?.dealCoupouns || [];
    const isDealCouponLoading = state?.dealsDataSlice?.allofferData?.isLoading;
    return {
      dealCouponData: data?.filter((filterData) => filterData?.enabled),
      isDealCouponLoading,
    };
  });
};

const OfferFilteredDealsData = () => {
  return useSelector((state) => {
    const data = state?.dealsDataSlice?.allofferData?.filteredDeals;
    const isDealFreqLoading = state?.dealsDataSlice?.allofferData?.isLoading;
    return {
      dealsFilter: data,
      isDealFreqLoading,
    };
  });
};

const OfferDealCouponFreqData = () => {
  return useSelector((state) => {
    const data = state?.dealsDataSlice?.allofferData?.dealCoupounFrequencies;
    const isDealFreqLoading = state?.dealsDataSlice?.allofferData?.isLoading;
    return {
      dealCouponFreqData: state?.dealsDataSlice?.dealCoupounFrequencies ? data?.items?.filter((filterData) => filterData?.enabled) : data?.filter((filterData) => filterData?.enabled),
      isDealFreqLoading,
    };
  });
};

const OfferDealCouponCodeData = () => {
  return useSelector((state) => {
    const data = state?.dealsDataSlice?.allofferData?.getDealCouponCodeData || [];
    const isDealCouponCodeLoading = state?.dealsDataSlice?.allofferData?.isLoading;
    const isDealCouponCodePostLoading =
      state?.dealsDataSlice?.allofferData?.isPostLoading;

    return {
      dealCouponCodeData: data?.filter((filterData) => filterData?.enabled),
      isDealCouponCodeLoading,
      isDealCouponCodePostLoading,
    };
  });
};





const encodeBase64 = (data) => {
  return Buffer?.from(data).toString('base64');
}
const decodeBase64 = (data) => {
  return Buffer?.from(data, 'base64').toString('ascii');
}


// flexible tracker
const trackEvent = (eventName, payload = {}) => {
  const data = {
    event: eventName,
    ...payload,
  };
  console.log("trackEvent =>", data);
  window?.dataLayer?.push(data);
};

const formatIndianNumber = (num) => {
  if (typeof num !== "number" || isNaN(num)) return num;
  return num?.toLocaleString("en-IN");
};

const SectionMasterDataBySectionId = (login, id) => {
  return useSelector((state) => {
    const data = state?.homePageSliceReducer?.homePageData?.sectionMasters || [];
    const isSectionLoading = login ? state?.homePageSliceReducer?.isPostLoginLoading : state?.homePageSliceReducer?.isgetLoading;
    return {
      sectionMasterData: data?.filter((filterData) => (filterData?.enabled && filterData?.id === id))
        .sort((a, b) =>
          !login
            ? a.nonLoginDisplayOrder - b.nonLoginDisplayOrder
            : a.displayOrder - b.displayOrder
        ),
      isSectionLoading,
    };
  });
};


/**
 * dispatchAsync
 * ----------------
 * Utility helper to make Redux-Saga actions awaitable.
 *
 * WHY THIS VERSION:
 * - Guarantees the returned Promise ALWAYS settles (no deadlocks)
 * - Prevents UI freeze when saga forgets to call resolve/reject
 * - Works with existing saga resolve/reject pattern
 * - Safe to use with Promise.all / Promise.allSettled
 *
 * DESIGN DECISION:
 * - We prefer UX safety over strict rejection
 * - Errors are logged, but the Promise is force-resolved if needed
 *
 * @param {Function} dispatch        Redux dispatch function
 * @param {Function} actionCreator   Redux action creator handled by a saga
 * @param {any} payload              Payload forwarded to the saga
 * @param {string} label             Optional label for logs/debugging
 * @param {number} timeoutMs         Max wait time before force-resolve
 *
 * @returns {Promise<any>} ALWAYS resolves (never hangs)
 */
const dispatchAsync = (
  dispatch,
  actionCreator,
  payload,
  label = "DISPATCH_ASYNC",
  timeoutMs = 10000
) =>
  new Promise((resolve) => {
    let settled = false;

    /**
     * safeResolve
     * -----------
     * Ensures resolve is called only once.
     * Any value (success, error, null) completes the Promise.
     */
    const safeResolve = (value) => {
      if (settled) return;
      settled = true;
      clearTimeout(timeoutId);
      resolve(value ?? null);
    };

    /**
     * Timeout safeguard
     * -----------------
     * If saga never calls resolve/reject (bug, cancellation, early return),
     * we force-resolve to avoid blocking the user journey.
     */
    const timeoutId = setTimeout(() => {
      console.warn(`[${label}] timed out after ${timeoutMs}ms — force resolve`);
      safeResolve(null);
    }, timeoutMs);

    /**
     * Dispatch saga action
     * --------------------
     * We inject resolve/reject into the payload.
     * NOTE: reject is intentionally converted into resolve to
     * guarantee Promise settlement.
     */
    dispatch(
      actionCreator({
        payload,
        resolve: (data) => {
          //check for values not comming in 2dn api call
          safeResolve(data);
        },
        reject: (error) => {
          console.warn(`[${label}] saga rejected`, error);
          safeResolve(null); // convert reject → resolve (UX safe)
        }
      })
    );
  });

const createCategoiesTabData = (categories) => {
  const tabData = categories?.reduce((acc, content) => {
    let obj = {
      value: content.text,
      isDefaultTab: content.isDefaultTab,
      sourceType: content?.contentSourceType,
      sectionContentId: content?.id
    }
    if (content?.contentSourceType === ("Offer Category")) {
      obj.key = content?.sourceValue ? content?.sourceValue : content?.linkedMasterId; //only for Top Category sourceValue is present and for other category linkedMasterId is present
      obj.isSourceValue = content?.sourceValue ? true : false;
      acc.push(obj);
    }
    else if (content?.contentSourceType === ("Offer Sub-Type")) {
      obj.key = content?.sourceValue
      obj.isSourceValue = true
      acc.push(obj);
    }
    return acc;
  }, []) || [];
  return tabData;
}

const getDealCategoryNames = (dealCategoryData, dealCategoryIds) => {
  const categoryIds = new Set();
  if (dealCategoryIds) {
    dealCategoryIds.forEach((id) => categoryIds.add(String(id)));
  }
  const names = dealCategoryData
    ?.filter((dealCategory) => categoryIds.has(String(dealCategory.id)))
    .map((dealCategory) => dealCategory.name) || [];

  return names.length ? names.join(", ") : "";
};

const getImageName = (url) => {
  const fileName = url.split('/').pop();
  // first underscore position
  const firstUnderscore = fileName.indexOf('_');
  // remove GUID part
  const imageNameWithExt =
    firstUnderscore !== -1
      ? fileName.substring(firstUnderscore + 1)
      : fileName;
  // remove extension
  const lastDotIndex = imageNameWithExt.lastIndexOf('.');
  return lastDotIndex !== -1
    ? imageNameWithExt.substring(0, lastDotIndex)
    : imageNameWithExt;
};
const DefaultCardName = () => {
  return useSelector((state) => {
    const defaultCardIdentifier = state?.validateLoginTokenSliceReducer?.data?.subIdentifier;
    const allCards = state?.utilityReducer?.creditCards || [];

    const activeCards = allCards?.filter((card) => card?.status === "1") || [];
    const cards = activeCards.length ? activeCards : allCards;

    if (!cards?.length) return "NA";

    const selectedCard = cards.find(
      (card) => card?.identifier === defaultCardIdentifier
    );
    if (selectedCard?.CardTypeName) return selectedCard.CardTypeName || "NA";

    const defaultCreditCard = cards.find(
      (card) => card?.identifiertype === "1002"
    );
    if (defaultCreditCard?.CardTypeName) return defaultCreditCard.CardTypeName || "NA";

    return cards[0]?.CardTypeName || "NA";
  });
};

export {
  ClientId,
  ClientPlatformCode,
  UserIdAndStatusData,
  UserId,
  SectionMasterData,
  SectionContentMasterData,
  DealCategoryData,
  DealData,
  DealCouponData,
  ProductContentData,
  DealCouponFreqData,
  DealCouponCodeData,
  NavConfigureData,
  GetMemberData,
  GetSegment,
  GetSwitchAccount,
  PointPerPrice,
  ApiConfigData,
  ThemeData,
  ApiConfigDataLoading,
  ThemeDataLoading,
  AppTitle,
  AppLogo,
  handleRedirectWithLoading,
  ModalOrSso,
  UtilityReducer,
  FormatDate,
  VoucherHistoryReducer,
  CustomFormatNumber,
  ValidateLoginToken,
  UserCardBase,
  FetchDealData,
  ApplyThemeStyles,
  clientType,
  TruncateName,
  GetImageUrl,
  Login,
  ShouldShowSection,
  GetMobWebCta,
  SectionMasterData_2,
  SectionContentMasterData_2,
  DealCategoryData_2,
  DealData_2,
  DealCouponData_2,
  ProductContentData_2,
  DealCouponFreqData_2,
  DealCouponCodeData_2,
  encodeBase64,
  decodeBase64,
  UnlocksectionactivityData,
  OfferDealCouponCodeData,
  OfferSectionMasterData,
  OfferSectionContentMasterData,
  OfferDealCategoryData,
  OfferDealData,
  OfferDealCouponData,
  OfferDealCouponFreqData,
  OfferFilteredDealsData,
  trackEvent,
  formatIndianNumber,
  MyAccountSectionMasterData,
  MyAccountSectionContentMasterData,
  SectionMasterDataBySectionId,
  dispatchAsync,
  createCategoiesTabData,
  getDealCategoryNames,
  getImageName,
  DefaultCardName
};
